import Vue from "vue";
import VueRouter from "vue-router";
import { constantRoutes } from "@/router/routerMap";

const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};

Vue.use(VueRouter);

const createRouter = () =>
  new VueRouter({
    mode: "history",
    base: process.env.BASE_URL,
    routes: constantRoutes,
  });

const router = createRouter();

export function resetRouter() {
  const newRouter = createRouter();
  router.matcher = newRouter.matcher;
}
router.selfaddRoutes = function (params){
  router.matcher = createRouter().matcher;
  router.addRoutes(params)
}

export default router;
